import React, { useEffect } from 'react';
import { Box, Button } from '@mui/material';
import { getScrollEdgeFadeHorizontalSx, useScrollEdgeFade } from '../../hooks/useScrollEdgeFade';
import { LEADS_TEXT_SECONDARY } from './leadsUi.styles';

const filterChipSx = (active) => ({
  textTransform: 'none',
  minWidth: 0,
  maxWidth: 168,
  height: 24,
  px: 1,
  borderRadius: '12px',
  fontSize: '12px',
  fontWeight: active ? 600 : 500,
  color: active ? '#FFFFFF' : LEADS_TEXT_SECONDARY,
  bgcolor: active ? 'rgba(255,255,255,0.12)' : 'transparent',
  flexShrink: 0,
  '&:hover': { bgcolor: 'rgba(255,255,255,0.08)', color: '#FFFFFF' },
});

/**
 * Filtro del detalle por registro. Recorta intereses, consultas y actividad.
 * Todos vuelve a mostrar el lead completo.
 *
 * @param {{ options: { id: string, label: string }[], value: string,
 *   onChange: (id: string) => void }} props
 */
export default function LeadRecordFilter({ options, value, onChange }) {
  const { scrollRef, fadeLeft, fadeRight, refreshScrollEdges } = useScrollEdgeFade({ axis: 'x' });

  useEffect(() => {
    refreshScrollEdges();
  }, [refreshScrollEdges, options]);

  if (!options?.length) return null;

  return (
    <Box
      ref={scrollRef}
      role="group"
      aria-label="Filtrar por registro"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        minWidth: 0,
        overflowX: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
        ...getScrollEdgeFadeHorizontalSx(fadeLeft, fadeRight),
      }}
    >
      <Button
        size="small"
        aria-pressed={value === 'all'}
        onClick={() => onChange('all')}
        sx={filterChipSx(value === 'all')}
      >
        Todos
      </Button>
      {options.map((option) => {
        const active = value === option.id;
        return (
          <Button
            key={option.id}
            size="small"
            aria-pressed={active}
            title={option.label}
            onClick={() => onChange(active ? 'all' : option.id)}
            sx={filterChipSx(active)}
          >
            <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {option.label}
            </Box>
          </Button>
        );
      })}
    </Box>
  );
}
